import { PaymentGatewayLog } from './gateway-log.model'

export interface GatewayLogState {
  [key: string]: PaymentGatewayLog[]
}

export const initialGatewayLogState: GatewayLogState = {}
